const forge = require('node-forge');

export namespace Crypto {
  export const encryptText = (key: string, text: string): string => {
    const publicKey = forge.pki.publicKeyFromPem(key);
    const encrypted = publicKey.encrypt(text, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: { md: forge.md.sha1.create() },
    });

    return forge.util.encode64(encrypted);
  };

  export const decryptText = (privateKeyPem: string, encryptedText: string): string => {
    const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);
    const encryptedBytes = forge.util.decode64(encryptedText);
    const decrypted = privateKey.decrypt(encryptedBytes, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: { md: forge.md.sha1.create() },
    });

    return decrypted;
  };
}
